export default __webpack_public_path__ + "static/media/hardedit_manually_stored_products.0d887680.jpg";